import { useEffect } from 'react';
import { useTranslations } from 'next-intl';
import { toasterApi } from '@terra/ui-design-system';
import {
  consumeTorchNotSupportedToast,
  TORCH_NOT_SUPPORTED_TOAST_DURATION_MS,
} from './torch-not-supported-toast';

export function usePendingTorchNotSupportedToast(): void {
  const t = useTranslations('signIn');

  useEffect(() => {
    if (!consumeTorchNotSupportedToast()) {
      return;
    }

    toasterApi.error({
      title: t('toasts.torchNotSupported.title'),
      description: t('toasts.torchNotSupported.description'),
      duration: TORCH_NOT_SUPPORTED_TOAST_DURATION_MS,
    });
  }, [t]);
}
